import { z } from 'zod';
import { ExportJobStatusSchema, FilePurposeSchema } from '../lib/enums';
import { zIsoDateTime, zSha256Hex, zUuid } from './common';
/**
 * Files + export jobs. Files live on local disk under
 * `build/data/uploads/<company_id>/`; cross-tenant file access exists ONLY
 * via the two enumerated seam clauses (granted scope-package attachments,
 * COI on a vetting submission tied to your grant).
 */
export const FileSchema = z.object({
    id: zUuid,
    companyId: zUuid,
    filename: z.string().min(1).max(300),
    mimeType: z.string().min(1).max(150),
    size: z.number().int().min(0),
    sha256: zSha256Hex,
    purpose: FilePurposeSchema,
    createdAt: zIsoDateTime,
});
/** Public-safe subset for referencing a file in cross-tenant / client surfaces. */
export const FileRefSchema = z.object({
    id: zUuid,
    filename: z.string().min(1).max(300),
    mimeType: z.string().min(1).max(150),
    size: z.number().int().min(0),
});
/** Multipart field metadata accompanying `POST /files`. */
export const UploadFileRequestSchema = z.object({
    purpose: FilePurposeSchema,
});
export const UploadFileResponseSchema = FileSchema;
// -------------------------------------------------------------------- exports
export const ExportJobSchema = z.object({
    id: zUuid,
    status: ExportJobStatusSchema,
    requestedAt: zIsoDateTime,
    completedAt: zIsoDateTime.nullable(),
    fileId: zUuid.nullable(),
    error: z.string().nullable(),
});
export const CreateExportResponseSchema = ExportJobSchema;
//# sourceMappingURL=files.js.map